<template>
  <div>
    <form class="myForm mt-5">
      <div class="form-group row">
        <label for="nome" class="col-sm-2 col-form-label">Unidade:<span class="text-danger"> *</span></label>
        <div class="col-sm-4">
            <input class="form-control" type="text" v-model="unidade">
        </div>
        <label for="nome" class="col-sm-2 col-form-label">Tipo da unidade<span class="text-danger"> *</span></label>
        <div class="col-sm-4">
          <multiselect v-model="valueUnida" select-label="" deselect-label="X" selectedLabel="" :options="optionsUnid" placeholder="Selecione uma Unidade" label="unidade" track-by="code"><span slot="noResult" class="text-info">Nenhum tipo de Unidade encontrado</span></multiselect>
        </div>
      </div>
      <div class="form-group row">
        <label for="nome" class="col-sm-2 col-form-label">Logradouro:</label>
        <div class="col-sm-4">
            <input class="form-control" type="text" v-model="logradouro">
        </div>
        <label for="nome" class="col-sm-2 col-form-label">Número:</label>
        <div class="col-sm-4">
            <input class="form-control" type="text" v-model="numero">
        </div>
      </div>

      <div class="form-group row">
        <label for="nome" class="col-sm-2 col-form-label">Bairro:</label>
        <div class="col-sm-4">
            <input class="form-control" type="text" v-model="bairro">
        </div>
        <label for="nome" class="col-sm-2 col-form-label">CEP:</label>
        <div class="col-sm-4">
            <the-mask type="text" mask="#####-###" class="form-control" v-model="cep"></the-mask>
        </div>
      </div>

      <div class="form-group row">
        <label for="nome" class="col-sm-2 col-form-label">Cidade:</label>
        <div class="col-sm-4">
          <input class="form-control" type="text" v-model="cidade">
        </div>
        <label for="nome" class="col-sm-2 col-form-label">Estado:</label>
        <div class="col-sm-4">
          <input class="form-control" type="text" v-model="estado">
        </div>
      </div>

      <label for="nome" class="col-sm-6 col-form-label mt-3 mb-3"><b>INCLUIR FORNECEDOR</b></label>
      <div class="row mb-4">
        <div class="col-sm-3">
          <multiselect v-model="valueFornec" tag-placeholder="Selecione" placeholder="Selecione um fornecedor" selected-label="" deselect-label="X" selectedLabel="" label="name" track-by="code" :options="optionsForn" @input="incluirForn(valueFornec.code)" @remove="removeForn"><span slot="noResult" class="text-info">Fornecedor não encontrado</span></multiselect>
        </div>

        <div class="col-sm-3" v-if="comboTipoFor">
            <multiselect v-model="value" placeholder="Selecione um fornecimento" label="name" track-by="code" select-label="" deselect-label="X" selectedLabel="" :options="options"><span slot="noResult" class="text-info">Tipo não encontrado</span></multiselect>
        </div>
        <div class="col-sm-5" v-if="comboTipoFor">
              <input class="form-control" type="text" v-model="contrato" placeholder="Contrato/Registro">
        </div>
        <button class="btn btn-sm btn-primary mr-2 btn-cc" v-if="comboTipoFor" type="button" @click="adicionar" title="Adicionar" :disabled="( !contrato != '' || !value != '')"><i class="fas fa-plus"></i></button>
        <button class="btn btn-sm btn-danger btn-cc" v-if="comboTipoFor" type="button" @click="cancelar" title="Cancelar"><i class="fas fa-times"></i></button>
      </div>

      <div class="row mt-5" v-if="lista || tpfornec != ''">
        <table class="table col-12">
          <tr>
            <th class="text-center col-3">Fornecedor</th>
            <th class="text-center col-3">Tipo Fornecimento</th>
            <th class="text-center col-4">Contrato</th>
            <th class="text-center col-2">Ações</th>
          </tr>
          <tr v-for="(forn, i) of tpfornec" :key="i">
            <td>{{forn.fornecedor}}</td>
            <td>{{forn.tipoFo}}</td>
            <td>{{forn.contr}}</td>
            <td class="text-center"><button type="button" class="btn btn-sm btn-danger" @click="remover(i)"><i class="fa fa-trash"></i></button></td>
          </tr>
        </table>
      </div>
  </form>
    <div class="container text-right mt-5">
      <button class="btn btn-sm btn-danger" @click="retorno">Cancelar</button>
      <button class="btn btn-sm btn-success ml-2" :disabled="((unidade == '' || valueUnida == '' || valueUnida == null) || ((valueFornec != null && valueFornec != '' && tpfornec == '') || comboTipoFor))" @click="salvar">Salvar</button>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'UnidadesEditar',
  props: {
    id: Number
  },
  components: {
    Multiselect
  },
  data() {
    return {
        unidade: '',
        logradouro: '',
        comUnidades: '',
        numero: '',
        cep: '',
        bairro: '',
        cidade: '',
        estado: '',
        contrato: '',
        tpfornec: [],
        options: [],
        optionsForn: [],
        value: [],
        valueFornec: [],
        valueUnida: [],
        optionsUnid: [],
        comboTipoFor: false,
        lista: false

    }
  },
  methods: {
      retorno() {
        this.$router.go(0)
      },
      incluirForn(valueFornec){
        this.comboTipoFor = true;
        this.value = null;
        this.contrato = '';
        this.options = [];

       api.enviarRequisicao('get', '/api/contas-consumo/tipo-fornecimentos/fornecedor/'+valueFornec)
       .then(response => {
        for(var i = 0;i < response.data.length;i++){
           this.options.push({name : response.data[i].tp01_descricao, code: response.data[i].tp01_id})
         }
       })
      },

      cancelar(){
        this.comboTipoFor = false;
        this.value = null;
        this.valueFornec = null;
        this.contrato = '';
      },

      removeForn() {
        this.comboTipoFor = false
      },

      adicionar(){
        this.tpfornec.push({fornecedor: this.valueFornec.name,idFor: this.valueFornec.code, tipoFo : this.value.name, idTipo: this.value.code,contr : this.contrato})
        this.contrato = ''
        this.lista = true
        this.comboTipoFor = false
        this.value = null
        this.valueFornec = null
      },
      remover(i){
        this.tpfornec.splice(i,1)
        if(this.tpfornec == '' || this.comboTipoFor == ''){
          this.comboTipoFor = false
          this.lista = false
        }
      },
      salvar() {
        let contratos = [];

        for(var i = 0; i < this.tpfornec.length; i++){
          contratos.push({ba04_numero: this.tpfornec[i].contr, ba04_tpfornecimento_id: this.tpfornec[i].idTipo,ba04_fornecedor_id: this.tpfornec[i].idFor})
        }

        api.enviarRequisicao('put', '/api/contas-consumo/unidades/'+ this.id, {
          ba02_unidade: this.unidade,
          ba02_tpunidade_id: this.valueUnida.code,
          ba01_logradouro: this.logradouro,
          ba01_numero: this.numero,
          ba01_bairro: this.bairro,
          ba01_cep: this.cep,
          ba01_cidade: this.cidade,
          ba01_estado: this.estado,
          contrato: contratos

        }).then(response => {
          this.$swal('Atenção!','Dados salvos com sucesso.','success')
           .then(
              function () {
                  history.go(0)
              }
          );
        })
        .catch(function (error) {
          this.$swal('Atenção!','Erro ao cadastrar os dados.','error')
        })
      },
  },
  mounted: function() {
    api.enviarRequisicao('get', '/api/contas-consumo/tipo-unidades')
    .then(response => {
      for(var i = 0;i < response.data.length;i++){
        this.optionsUnid.push({unidade : response.data[i].tp00_descricao, code: response.data[i].tp00_id})
      }
    })

    api.enviarRequisicao('get', '/api/contas-consumo/fornecedores')
      .then(response => {
        for(var i = 0;i < response.data.length;i++){
          this.optionsForn.push({name : response.data[i].ba00_fornecedor, code: response.data[i].ba00_id})
        }
    })

    api.enviarRequisicao('get', '/api/contas-consumo/unidades/'+this.id)
      .then(response => {
        for(var i = 0;i < response.data.length;i++){
          if(response.data[i].ba00_fornecedor != null ){
            this.tpfornec.push({fornecedor : response.data[i].ba00_fornecedor,idFor: response.data[i].ba00_id, tipoFo: response.data[i].tp01_descricao, idTipo: response.data[i].tp01_id , contr: response.data[i].ba04_numero})
          }
        }

        this.unidade = response.data[0].ba02_unidade,
        this.valueUnida = {unidade: response.data[0].tp00_descricao,code:response.data[0].ba02_tpunidade_id},
        this.logradouro = response.data[0].ba01_logradouro,
        this.numero = response.data[0].ba01_numero,
        this.bairro = response.data[0].ba01_bairro,
        this.cidade = response.data[0].ba01_cidade,
        this.estado = response.data[0].ba01_estado,
        this.cep = response.data[0].ba01_cep

    })
  }

}
</script>


<style scoped>
.salvar {
  background-color: #18A689;
  color: #fff;
  font-size: 12px;
  text-decoration: none;
}

.btn-cc{
  height: 40px;
}
</style>
